<template>
  <div class="select-place">
    <BaseAlertInline v-if="!is_selected_restaurant"
                     :value="$t('Виберіть один із закладів, які підтримують послугу онлайн замовлення.')"
                     class="_warning select-place__alert"/>
    <div class="select-place__items" :class="{_loading: pending_restaurants}">
      <BasePreloader v-if="pending_restaurants"/>
      <div v-else
           class="select-place__items-list">
        <template v-for="item in all_restaurants">

          <router-link v-if="item.online_delivery"
                       :key="item.id"
                       :to="{name: 'delivery', params: {restaurantId: item.id}}"
                       class="select-place__item"
                       :class="{'_active': activeRestaurantId == item.id}"
                       @click.native="onSetActive(item.id)">
            <div class="select-place__item-img">
              <img :src="item.image" :alt="item.name">
            </div>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  name: 'SelectPlace',
  computed: {
    ...mapState('restaurants', ['pending_restaurants']),
    ...mapState('restaurants', ['all_restaurants']),
    ...mapState('restaurants', ['active_restaurant']),
    activeRestaurantId() {
      let id = window.localStorage.getItem('active_restaurant_id') || null
      if (this.active_restaurant) {
        id = this.active_restaurant.id
      }
      return id
    },
    is_selected_restaurant() {
      return JSON.parse(window.localStorage.getItem('is_selected_restaurant') || null) || false
    }
  },
  methods: {
    ...mapActions('restaurants', ['setActiveRestaurant']),
    onSetActive(id) {
      if (id !== this.active_restaurant.id) {
        this.setActiveRestaurant(id)
      }

      if (!this.is_selected_restaurant) {
        window.localStorage.setItem('is_selected_restaurant', 'true')
      }

      this.$vModal.close('select-place')
    }
  }
}
</script>

<style>

</style>
